webpackJsonp([11],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// lazy loading Components
// https://github.com/vuejs/vue-router/blob/dev/examples/lazy-loading/app.js#L8
exports.default = function (name) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    return __webpack_require__(29)("./" + name + (index ? '/index' : '') + '.vue');
  };
};

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TOGGLE_DEVICE = exports.TOGGLE_DEVICE = 'TOGGLE_DEVICE';

var TOGGLE_SIDEBAR = exports.TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

var EXPAND_MENU = exports.EXPAND_MENU = 'EXPAND_MENU';

var SWITCH_EFFECT = exports.SWITCH_EFFECT = 'SWITCH_EFFECT';

var OPEN_NOTIFICATION = exports.OPEN_NOTIFICATION = 'OPEN_NOTIFICATION';

var CLEAR_NOTE_QUEUE = exports.CLEAR_NOTE_QUEUE = 'CLEAR_NOTE_QUEUE';

var SET_AUTH = exports.SET_AUTH = 'auth/login';

var UPDATE_ENDPOINT = exports.UPDATE_ENDPOINT = 'UPDATE_ENDPOINT';

var REGISTER_DATA_REFRESH = exports.REGISTER_DATA_REFRESH = 'REGISTER_DATA_REFRESH';
var DEREGISTER_DATA_REFRESH = exports.DEREGISTER_DATA_REFRESH = 'DEREGISTER_DATA_REFRESH';
var DATA_REFRESH = exports.DATA_REFRESH = 'DATA_REFRESH';

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = {
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Basic ' + "RVY3bXdHR2RvRzh0OGVpNnlxYnFGd202OjVIQ3RRdWVhaGcrYXNpRFVUN1lnUVUzRUMwa3BjU1piZENQbjNES2p6WEp4SnVQdQ=="
  },
  timeout: 3000
};

var api = {
  call: function call() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var options = {
      method: opts.method || 'get',
      baseURL: opts.baseURL || '',
      url: opts.url || 'admin/v1/',
      params: opts.params || null,
      data: opts.data || null,
      timeout: opts.timeout || init.timeout,
      maxContentLength: 10000,
      headers: Object.assign({
        access_token: opts.access_token
      }, init.headers, opts.headers)
    };
    return (0, _axios2.default)(options);
  }
};

exports.default = api;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mutationTypes = __webpack_require__(4);

var types = _interopRequireWildcard(_mutationTypes);

var _lazyLoading = __webpack_require__(2);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

var _users = __webpack_require__(62);

var _users2 = _interopRequireDefault(_users);

var _classes = __webpack_require__(56);

var _classes2 = _interopRequireDefault(_classes);

var _transactions = __webpack_require__(61);

var _transactions2 = _interopRequireDefault(_transactions);

var _products = __webpack_require__(59);

var _products2 = _interopRequireDefault(_products);

var _contracts = __webpack_require__(57);

var _contracts2 = _interopRequireDefault(_contracts);

var _reports = __webpack_require__(60);

var _reports2 = _interopRequireDefault(_reports);

var _ops = __webpack_require__(58);

var _ops2 = _interopRequireDefault(_ops);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// show: meta.label -> name
// name: component name
// meta.label: display label

var state = {
  items: [
  /* {
    name: 'Dashboard',
    path: '/dashboard',
    meta: {
      auth: true,
      icon: 'fa-tachometer',
      link: 'dashboard/index.vue'
    },
    component: lazyLoading('dashboard', true)
  }, */
  _users2.default, _classes2.default, _products2.default, _contracts2.default, _transactions2.default, _reports2.default, _ops2.default, {
    name: 'Support',
    path: '/support',
    meta: {
      auth: true,
      icon: 'fa-question-circle',
      link: 'support/index.vue'
    },
    component: (0, _lazyLoading2.default)('support', true)
  }]
};

var mutations = _defineProperty({}, types.EXPAND_MENU, function (state, menuItem) {
  if (menuItem.index > -1) {
    if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
      state.items[menuItem.index].meta.expanded = menuItem.expanded;
    }
  } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
    menuItem.item.meta.expanded = menuItem.expanded;
  }
});

exports.default = {
  state: state,
  mutations: mutations
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(88)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(119),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(94)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(125),
  /* scopeId */
  "data-v-afc87e34",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(83)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(114),
  /* scopeId */
  "data-v-0a4fbb49",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(85)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(116),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(48);

_app.app.$mount('#app');

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var N_ERROR = exports.N_ERROR = 'triggerErrorNote';

var N_SUCCESS = exports.N_SUCCESS = 'triggerSuccessNote';

var DATA_REFRESH = exports.DATA_REFRESH = 'triggerDataRefresh';

var UPDATE = exports.UPDATE = 'upsert';

var DELETE = exports.DELETE = 'del';

var LOOKUP = exports.LOOKUP = 'lookup';

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(23);


/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Home.vue": [
		20
	],
	"./auth/Login.vue": [
		21
	],
	"./classes/index.vue": [
		133,
		1
	],
	"./contracts/index.vue": [
		134,
		3
	],
	"./dashboard/index.vue": [
		135,
		0
	],
	"./ops/index.vue": [
		136,
		9
	],
	"./products/index.vue": [
		137,
		2
	],
	"./reports/Default.vue": [
		138,
		6
	],
	"./reports/User.vue": [
		139,
		7
	],
	"./reports/index.vue": [
		140,
		10
	],
	"./settings/index.vue": [
		22
	],
	"./support/index.vue": [
		141,
		8
	],
	"./transactions/index.vue": [
		142,
		5
	],
	"./users/index.vue": [
		143,
		4
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 29;

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = exports.router = exports.app = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _vueNprogress = __webpack_require__(128);

var _vueNprogress2 = _interopRequireDefault(_vueNprogress);

var _vuexRouterSync = __webpack_require__(10);

var _App = __webpack_require__(102);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(51);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(53);

var _store2 = _interopRequireDefault(_store);

var _filters = __webpack_require__(50);

var filters = _interopRequireWildcard(_filters);

var _mutationTypes = __webpack_require__(4);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.router = _router2.default;
_vue2.default.use(_vueNprogress2.default);

// Enable devtools
// Vue.config.devtools = true

(0, _vuexRouterSync.sync)(_store2.default, _router2.default);

var nprogress = new _vueNprogress2.default({ parent: '.nprogress-container' });

var state = _store2.default.state;


_router2.default.beforeEach(function (route, from, next) {
  if (state.app.device.isMobile && state.app.sidebar.opened) {
    _store2.default.commit(_mutationTypes.TOGGLE_SIDEBAR, false);
  }
  if (route.matched.some(function (record) {
    return record.meta.auth;
  })) {
    // route requires auth
    if (!_store2.default.getters['auth/ok']) {
      next({
        path: '/login',
        query: { redirect: route.fullPath }
      });
    } else {
      next();
    }
  }
  next();
});

Object.keys(filters).forEach(function (key) {
  _vue2.default.filter(key, filters[key]);
});

var app = new _vue2.default(_extends({
  router: _router2.default,
  store: _store2.default,
  nprogress: nprogress
}, _App2.default));

exports.app = app;
exports.router = _router2.default;
exports.store = _store2.default;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notifications = exports.FooterBar = exports.AppMain = exports.Sidebar = exports.Navbar = undefined;

var _Navbar2 = __webpack_require__(107);

var _Navbar3 = _interopRequireDefault(_Navbar2);

var _Sidebar2 = __webpack_require__(109);

var _Sidebar3 = _interopRequireDefault(_Sidebar2);

var _AppMain2 = __webpack_require__(104);

var _AppMain3 = _interopRequireDefault(_AppMain2);

var _FooterBar2 = __webpack_require__(105);

var _FooterBar3 = _interopRequireDefault(_FooterBar2);

var _Notifications2 = __webpack_require__(108);

var _Notifications3 = _interopRequireDefault(_Notifications2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Navbar = _Navbar3.default;
exports.Sidebar = _Sidebar3.default;
exports.AppMain = _AppMain3.default;
exports.FooterBar = _FooterBar3.default;
exports.Notifications = _Notifications3.default;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(8);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _menu = __webpack_require__(18);

var _menu2 = _interopRequireDefault(_menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'is-active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    name: 'Home',
    path: '/',
    component: __webpack_require__(20)
  }, {
    name: 'Login',
    path: '/login',
    component: __webpack_require__(21)
  }, {
    name: 'Settings',
    path: '/settings',
    component: __webpack_require__(22)
  }].concat(_toConsumableArray(generateRoutesFromMenu(_menu2.default.state.items)), [{
    path: '*',
    redirect: '/'
  }])
});

// Menu should have 2 levels.
function generateRoutesFromMenu() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var routes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  for (var i = 0, l = menu.length; i < l; i++) {
    var item = menu[i];
    if (item.path) {
      routes.push(item);
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes);
    }
  }
  return routes;
}

exports.default = router;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.del = exports.upsert = exports.lookup = exports.triggerDataRefresh = exports.triggerSuccessNote = exports.triggerErrorNote = exports.switchEffect = exports.expandMenu = exports.toggleDevice = exports.toggleSidebar = undefined;

var _mutationTypes = __webpack_require__(4);

var types = _interopRequireWildcard(_mutationTypes);

var _api = __webpack_require__(17);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var toggleSidebar = exports.toggleSidebar = function toggleSidebar(_ref, config) {
  var commit = _ref.commit;

  if (config instanceof Object) {
    commit(types.TOGGLE_SIDEBAR, config);
  }
};

var toggleDevice = exports.toggleDevice = function toggleDevice(_ref2, device) {
  var commit = _ref2.commit;
  return commit(types.TOGGLE_DEVICE, device);
};

var expandMenu = exports.expandMenu = function expandMenu(_ref3, menuItem) {
  var commit = _ref3.commit;

  if (menuItem) {
    menuItem.expanded = menuItem.expanded || false;
    commit(types.EXPAND_MENU, menuItem);
  }
};

var switchEffect = exports.switchEffect = function switchEffect(_ref4, effectItem) {
  var commit = _ref4.commit;

  if (effectItem) {
    commit(types.SWITCH_EFFECT, effectItem);
  }
};

var triggerErrorNote = exports.triggerErrorNote = function triggerErrorNote(_ref5, msg) {
  var commit = _ref5.commit;
  return commit(types.OPEN_NOTIFICATION, {
    type: 'danger',
    title: 'Error',
    message: msg || 'An error occured during the operation'
  });
};

var triggerSuccessNote = exports.triggerSuccessNote = function triggerSuccessNote(_ref6, msg) {
  var commit = _ref6.commit;
  return commit(types.OPEN_NOTIFICATION, {
    type: 'success',
    title: 'Success',
    message: msg || 'The operation completed successfully'
  });
};

var triggerDataRefresh = exports.triggerDataRefresh = function triggerDataRefresh(_ref7, payload) {
  var state = _ref7.state;
  return state.app.data_refresh_listeners.forEach(function (callback) {
    callback(payload);
  });
};

var lookup = exports.lookup = function lookup(_ref8, payload) {
  var getters = _ref8.getters,
      dispatch = _ref8.dispatch;

  _api2.default.call({
    method: 'get',
    baseURL: getters.endpointUrl,
    url: payload.url,
    params: Object.assign({}, payload.params),
    access_token: getters['auth/token']
  }).then(function (res) {
    if (payload.notify) {
      dispatch('triggerSuccessNote');
    }
    if (payload.callback) {
      payload.callback(res);
    }
  }).catch(function (err) {
    if (payload.notify) {
      dispatch('triggerErrorNote', err.response.data.message);
    }
    if (payload.failure) {
      payload.failure(err);
    }
  });
};

var upsert = exports.upsert = function upsert(_ref9, payload) {
  var getters = _ref9.getters,
      dispatch = _ref9.dispatch;

  var method = payload.method || 'post';
  method = method.toLowerCase();
  var data = null;
  var params = null;
  if (method === 'post' || method === 'put') {
    data = payload.data;
  } else {
    params = payload.data;
  }
  _api2.default.call({
    method: method,
    baseURL: getters.endpointUrl,
    url: payload.url,
    data: data,
    params: params,
    access_token: getters['auth/token']
  }).then(function (res) {
    if (payload.notify) {
      dispatch('triggerSuccessNote');
    }
    if (payload.callback) {
      payload.callback(res);
    }
  }).catch(function (err) {
    if (payload.notify) {
      dispatch('triggerErrorNote', err.response.data.message);
    }
    if (payload.failure) {
      payload.failure(err);
    }
  });
};

var del = exports.del = function del(_ref10, payload) {
  var getters = _ref10.getters,
      dispatch = _ref10.dispatch;

  _api2.default.call({
    method: 'delete',
    baseURL: getters.endpointUrl,
    url: payload.url,
    params: payload.params || payload.data,
    access_token: getters['auth/token']
  }).then(function (res) {
    if (payload.notify) {
      dispatch('triggerSuccessNote');
    }
    if (payload.callback) {
      payload.callback(res);
    }
  }).catch(function (err) {
    if (payload.notify) {
      dispatch('triggerErrorNote', err.response.data.message);
    }
    if (payload.failure) {
      payload.failure(err);
    }
  });
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _vuex2 = _interopRequireDefault(_vuex);

var _package = __webpack_require__(130);

var _package2 = _interopRequireDefault(_package);

var _vuexPersistedstate = __webpack_require__(9);

var _vuexPersistedstate2 = _interopRequireDefault(_vuexPersistedstate);

var _actions = __webpack_require__(52);

var actions = _interopRequireWildcard(_actions);

var _app = __webpack_require__(54);

var _app2 = _interopRequireDefault(_app);

var _menu = __webpack_require__(18);

var _menu2 = _interopRequireDefault(_menu);

var _auth = __webpack_require__(55);

var _auth2 = _interopRequireDefault(_auth);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var endpointOptions = [{ name: 'localhost', baseUrl: 'http://127.0.0.1:8888' }, { name: 'dev', baseUrl: 'https://dev.triseum.com/api' }, { name: 'staging', baseUrl: 'https://staging.triseum.com/api' }, { name: 'live', baseUrl: 'https://portal.triseum.com:8888' }, { name: 'live-eu', baseUrl: 'https://portal.europe.triseum.com:8888' }, { name: 'live-ap', baseUrl: 'https://portal.asia.triseum.com/api' }, { name: 'research', baseUrl: 'https://research.triseum.com/api' }];

if (true) {
  endpointOptions.shift();
}

var store = new _vuex2.default.Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  plugins: [(0, _vuexPersistedstate2.default)({ paths: ['auth.sessions', 'endpoint'] })],
  actions: actions,
  getters: {
    device: function device(state) {
      return state.app.device;
    },
    effect: function effect(state) {
      return state.app.effect;
    },
    menuitems: function menuitems(state) {
      return state.menu.items;
    },
    notifications: function notifications(state) {
      return state.app.notifications;
    },
    endpointUrl: function endpointUrl(state) {
      return state.endpointOptions.find(function (s) {
        return s.name === state.endpoint;
      }).baseUrl || 'dev';
    }
  },
  modules: {
    app: _app2.default,
    auth: _auth2.default,
    menu: _menu2.default
  },
  state: {
    pkg: _package2.default,
    endpoint: "live" || 'dev',
    endpointOptions: endpointOptions
  },
  mutations: {
    UPDATE_ENDPOINT: function UPDATE_ENDPOINT(state, newEndpoint) {
      state.endpoint = newEndpoint;
    }
  }
});

exports.default = store;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mutations;

var _mutationTypes = __webpack_require__(4);

var types = _interopRequireWildcard(_mutationTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var state = {
  device: {
    isMobile: false,
    isTablet: false
  },
  sidebar: {
    opened: false,
    hidden: false
  },
  effect: {
    translate3d: true
  },
  notifications: [],
  data_refresh_listeners: [],
  available_roles: {
    'instructor': 'instructor',
    'student': 'student'
  }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, types.TOGGLE_DEVICE, function (state, device) {
  state.device.isMobile = device === 'mobile';
  state.device.isTablet = device === 'tablet';
}), _defineProperty(_mutations, types.TOGGLE_SIDEBAR, function (state, config) {
  if (state.device.isMobile && config.hasOwnProperty('opened')) {
    state.sidebar.opened = config.opened;
  } else {
    state.sidebar.opened = true;
  }

  if (config.hasOwnProperty('hidden')) {
    state.sidebar.hidden = config.hidden;
  }
}), _defineProperty(_mutations, types.SWITCH_EFFECT, function (state, effectItem) {
  for (var name in effectItem) {
    state.effect[name] = effectItem[name];
  }
}), _defineProperty(_mutations, types.OPEN_NOTIFICATION, function (state, note) {
  state.notifications.push(note);
}), _defineProperty(_mutations, types.CLEAR_NOTE_QUEUE, function (state) {
  state.notifications.length = 0;
}), _defineProperty(_mutations, types.REGISTER_DATA_REFRESH, function (state, callback) {
  state.data_refresh_listeners.push(callback);
}), _defineProperty(_mutations, types.DEREGISTER_DATA_REFRESH, function (state, callback) {
  state.data_refresh_listeners = state.data_refresh_listeners.filter(function (c) {
    return c !== callback;
  });
}), _mutations);

exports.default = {
  state: state,
  mutations: mutations
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _actionTypes = __webpack_require__(24);

var _api = __webpack_require__(17);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  sessions: {}
};

var mutations = {
  login: function login(state, data) {
    _vue2.default.set(state.sessions, data.endpoint, {
      authenticated: true,
      scope: data.scope,
      type: data.token_type,
      access_token: data.access_token,
      expires: data.expires,
      rememberMe: data.rememberMe
    });
  },
  logout: function logout(state, data) {
    _vue2.default.set(state.sessions, data.endpoint, {
      authenticated: false,
      scope: '',
      type: '',
      access_token: ''
    });
  }
};

var getters = {
  ok: function ok(state, getters, rootState) {
    var o = state.sessions[rootState.endpoint];
    if (o) {
      return o.authenticated && Date.now() < o.expires;
    } else {
      return false;
    }
  },
  token: function token(state, getters, rootState) {
    if (getters.ok) {
      return state.sessions[rootState.endpoint].access_token;
    } else {
      return null;
    }
  },
  scope: function scope(state, getters, rootState) {
    if (getters.ok) {
      return state.sessions[rootState.endpoint].scope;
    } else {
      return 'not authed';
    }
  }
};

var actions = {
  login: function login(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch,
        rootGetters = _ref.rootGetters,
        rootState = _ref.rootState;

    _api2.default.call({
      method: 'post',
      baseURL: rootGetters.endpointUrl,
      url: '/oauth2/v1/token',
      data: Object.assign({
        'grant_type': 'password',
        'scope': 'admin support developer reporter'
      }, {
        username: payload.username,
        password: payload.password
      })
    }).then(function (res) {
      var data = res.data;
      data.expires = data.expires_in * 1000 + Date.now();
      dispatch(_actionTypes.N_SUCCESS, 'Login successful', { root: true });
      data.endpoint = rootState.endpoint;
      commit('login', data);
      if (payload.callback) {
        payload.callback(res);
      }
    }).catch(function (err) {
      dispatch(_actionTypes.N_ERROR, err.response.data.message, { root: true });
      if (payload.callback) {
        payload.callback(err.response);
      }
    });
  },
  logout: function logout(_ref2) {
    var commit = _ref2.commit,
        rootState = _ref2.rootState;

    commit('logout', { endpoint: rootState.endpoint });
  }
};

exports.default = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lazyLoading = __webpack_require__(2);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Classes',
  path: '/classes',
  meta: {
    auth: true,
    icon: 'fa-graduation-cap',
    link: 'classes/index.vue'
  },
  component: (0, _lazyLoading2.default)('classes', true)
  // children : []
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lazyLoading = __webpack_require__(2);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Contracts',
  path: '/contracts',
  meta: {
    auth: true,
    icon: 'fa-briefcase',
    link: 'contracts/index.vue'
  },
  component: (0, _lazyLoading2.default)('contracts', true)
  // children : []
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lazyLoading = __webpack_require__(2);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Operations',
  path: '/ops',
  meta: {
    auth: true,
    icon: 'fa-server',
    link: 'ops/index.vue'
  },
  component: (0, _lazyLoading2.default)('ops', true)
  // children : []
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lazyLoading = __webpack_require__(2);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Products',
  path: '/products',
  meta: {
    auth: true,
    icon: 'fa-cubes',
    link: 'products/index.vue'
  },
  component: (0, _lazyLoading2.default)('products', true)
  // children : []
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lazyLoading = __webpack_require__(2);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: '/reports',
  meta: {
    auth: true,
    icon: 'fa-bar-chart',
    expanded: false,
    label: 'Reports'
  },
  component: (0, _lazyLoading2.default)('reports', true),

  children: [{
    name: 'Reports',
    path: '',
    component: (0, _lazyLoading2.default)('reports/Default'),
    meta: {
      link: 'reports/Default.vue'
    }
  }, {
    name: 'User',
    path: 'user',
    meta: {
      description: 'Single User report',
      link: 'reports/User.vue'
    }
  }]
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lazyLoading = __webpack_require__(2);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Transactions',
  path: '/transactions',
  meta: {
    auth: true,
    icon: 'fa-money',
    link: 'transactions/index.vue'
  },
  component: (0, _lazyLoading2.default)('transactions', true)
  // children : []
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lazyLoading = __webpack_require__(2);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Users',
  path: '/users',
  meta: {
    auth: true,
    icon: 'fa-users',
    link: 'users/index.vue'
  },
  component: (0, _lazyLoading2.default)('users', true)
  // children : []
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NprogressContainer = __webpack_require__(112);

var _NprogressContainer2 = _interopRequireDefault(_NprogressContainer);

var _layout = __webpack_require__(49);

var _vuex = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Navbar: _layout.Navbar,
    Sidebar: _layout.Sidebar,
    AppMain: _layout.AppMain,
    FooterBar: _layout.FooterBar,
    NprogressContainer: _NprogressContainer2.default,
    Notifications: _layout.Notifications
  },

  beforeMount: function beforeMount() {
    var _this = this;

    var _document = document,
        body = _document.body;

    var WIDTH = 768;

    var handler = function handler() {
      if (!document.hidden) {
        var rect = body.getBoundingClientRect();
        var isMobile = rect.width < WIDTH;
        _this.toggleDevice(isMobile ? 'mobile' : 'other');
        _this.toggleSidebar({
          opened: !isMobile
        });
      }
    };

    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
  },


  computed: {
    sidebar: function sidebar() {
      return this.$store.state.app.sidebar;
    }
  },

  methods: (0, _vuex.mapActions)(['toggleDevice', 'toggleSidebar'])
}; //
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {

  props: {
    type: String,
    title: String,
    message: String,
    direction: {
      type: String,
      default: 'Right'
    },
    duration: {
      type: Number,
      default: 4500
    },
    container: {
      type: String,
      default: '.notifications'
    }
  },

  data: function data() {
    return {
      $_parent_: null,
      show: true
    };
  },
  created: function created() {
    var $parent = this.$parent;
    if (!$parent) {
      var parent = document.querySelector(this.container);
      if (!parent) {
        // Lazy creating `div.notifications` container.
        var className = this.container.replace('.', '');
        var Notifications = _vue2.default.extend({
          name: 'Notifications',
          render: function render(h) {
            return h('div', {
              'class': _defineProperty({}, '' + className, true)
            });
          }
        });
        $parent = new Notifications().$mount();
        document.body.appendChild($parent.$el);
      } else {
        $parent = parent.__vue__;
      }
      // Hacked.
      this.$_parent_ = $parent;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$_parent_) {
      this.$_parent_.$el.appendChild(this.$el);
      this.$parent = this.$_parent_;
      delete this.$_parent_;
    }
    if (this.duration > 0) {
      this.timer = setTimeout(function () {
        return _this.close();
      }, this.duration);
    }
  },
  destroyed: function destroyed() {
    this.$el.remove();
  },


  computed: {
    transition: function transition() {
      return 'bounce-' + this.direction;
    },
    enterClass: function enterClass() {
      return 'bounceIn' + this.direction;
    },
    leaveClass: function leaveClass() {
      return 'bounceOut' + this.direction;
    }
  },

  methods: {
    closedByUser: function closedByUser() {
      this.$emit('closed-by-user');
      clearTimeout(this.timer);
      this.show = false;
    },
    close: function close() {
      this.$emit('closed-automatically');
      clearTimeout(this.timer);
      this.show = false;
    },
    afterLeave: function afterLeave() {
      this.$destroy();
    }
  }
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classnames = __webpack_require__(80);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } //
//
//
//

// based on github.com/vue-bulma/tooltip


exports.default = {
  name: 'tooltip',
  abstract: true,

  props: {
    type: String,
    size: {
      type: String,
      default: 'medium',
      validator: function validator(value) {
        return ['small', 'medium', 'large'].includes(value);
      }
    },
    always: Boolean,
    noAnimate: Boolean,
    rounded: Boolean,
    label: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: 'bottom'
    }
  },

  render: function render() {
    var _classNames;

    var children = this.$slots.default;
    if (!children) {
      return;
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) {
      return c.tag;
    });
    /* istanbul ignore if */
    if (!children.length) {
      return;
    }

    var rawChild = children[0];

    rawChild.data.attrs = rawChild.data.attrs || {};
    Object.assign(rawChild.data.attrs, {
      'aria-label': this.label
    });

    rawChild.data.class = Array.isArray(rawChild.data.class) ? rawChild.data.class : [rawChild.data.class];
    rawChild.data.class.push((0, _classnames2.default)('tooltip', 'tooltip--' + this.placement, (_classNames = {}, _defineProperty(_classNames, 'tooltip--' + this.type, this.type), _defineProperty(_classNames, 'tooltip--' + this.size, this.size), _defineProperty(_classNames, 'tooltip--rounded', this.rounded), _defineProperty(_classNames, 'tooltip--always', this.always), _defineProperty(_classNames, 'tooltip--no-animate', this.noAnimate), _classNames)));

    return rawChild;
  },


  watch: {
    label: function label(val) {
      this.$el.setAttribute('aria-label', val);
    }
  }
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Levelbar = __webpack_require__(106);

var _Levelbar2 = _interopRequireDefault(_Levelbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: {
    sidebar: function sidebar() {
      return this.$store.state.app.sidebar;
    },
    hiddenSidebarStyle: function hiddenSidebarStyle() {
      return this.sidebar.hidden ? { 'margin-left': 0 } : null;
    }
  },

  components: {
    Levelbar: _Levelbar2.default
  }
}; //
//
//
//
//
//
//
//

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return this.$store.state.pkg;
  }
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueBulmaBreadcrumb = __webpack_require__(110);

var _vueBulmaBreadcrumb2 = _interopRequireDefault(_vueBulmaBreadcrumb);

var _Tooltip = __webpack_require__(19);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    Breadcrumb: _vueBulmaBreadcrumb2.default,
    Tooltip: _Tooltip2.default
  },

  data: function data() {
    return {
      list: null
    };
  },
  created: function created() {
    this.getList();
  },


  computed: {
    name: function name() {
      return this.$route.name;
    },
    endpoint: function endpoint() {
      return this.$store.state.endpoint;
    }
  },

  methods: {
    getList: function getList() {
      var matched = this.$route.matched.filter(function (item) {
        return item.name;
      });
      var first = matched[0];
      if (first && (first.name !== 'Home' || first.path !== '')) {
        matched = [{ name: 'Home', path: '/' }].concat(matched);
      }
      this.list = matched;
    }
  },

  watch: {
    $route: function $route() {
      this.getList();
    }
  }
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _Tooltip = __webpack_require__(19);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _vuex = __webpack_require__(5);

var _mutationTypes = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Tooltip: _Tooltip2.default
  },

  props: {
    show: Boolean
  },

  computed: {
    sidebar: function sidebar() {
      return this.$store.state.app.sidebar;
    },
    api: function api() {
      return {
        options: this.$store.state.endpointOptions
      };
    },
    pkginfo: function pkginfo() {
      return this.$store.state.pkg;
    },
    auth: function auth() {
      return this.$store.getters['auth/ok'];
    }
  },
  methods: _extends({
    logout: function logout() {
      // delete login
      this.$store.dispatch('auth/logout');
      this.$router.push('Home');
    },
    setEndpoint: function setEndpoint(event) {
      var selectedObject = this.api.options.find(function (i) {
        return i.name === event.target.getAttribute('data-value');
      });
      this.$store.commit(_mutationTypes.UPDATE_ENDPOINT, selectedObject.name);
      if (!this.$store.getters['auth/ok']) {
        this.logout();
      }
    }
  }, (0, _vuex.mapActions)(['toggleSidebar']))
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _Notification = __webpack_require__(103);

var _Notification2 = _interopRequireDefault(_Notification);

var _mutationTypes = __webpack_require__(4);

var _vuex = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationComponent = _vue2.default.extend(_Notification2.default);

var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

exports.default = {
  components: {
    Notification: _Notification2.default
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['notifications'])),
  watch: {
    'notifications': {
      handler: function handler(notes) {
        notes.forEach(function (n) {
          openNotification({
            title: n.title,
            message: n.message,
            type: n.type
          });
        });
        this.$store.commit(_mutationTypes.CLEAR_NOTE_QUEUE);
      },
      deep: true
    }
  }
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vueBulmaExpanding = __webpack_require__(111);

var _vueBulmaExpanding2 = _interopRequireDefault(_vueBulmaExpanding);

var _vuex = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Expanding: _vueBulmaExpanding2.default
  },

  props: {
    show: Boolean
  },

  data: function data() {
    return {
      isReady: false
    };
  },
  mounted: function mounted() {
    var route = this.$route;
    if (route.name) {
      this.isReady = true;
      this.shouldExpandMatchItem(route);
    }
  },


  computed: (0, _vuex.mapGetters)({
    menu: 'menuitems',
    device: 'device',
    auth: 'auth/ok',
    userRole: 'auth/scope'
  }),

  methods: _extends({}, (0, _vuex.mapActions)(['expandMenu']), {
    logout: function logout() {
      // delete login
      this.$store.dispatch('auth/logout');
      this.$router.push('Home');
    },
    isExpanded: function isExpanded(item) {
      return item.meta.expanded;
    },
    toggle: function toggle(index, item) {
      this.expandMenu({
        index: index,
        expanded: !item.meta.expanded
      });
    },
    shouldExpandMatchItem: function shouldExpandMatchItem(route) {
      var matched = route.matched;
      var lastMatched = matched[matched.length - 1];
      var parent = lastMatched.parent || lastMatched;
      var isParent = parent === lastMatched;

      if (isParent) {
        var p = this.findParentFromMenu(route);
        if (p) {
          parent = p;
        }
      }

      if ('expanded' in parent.meta && !isParent) {
        this.expandMenu({
          item: parent,
          expanded: true
        });
      }
    },
    generatePath: function generatePath(item, subItem) {
      return '' + (item.component ? item.path + '/' : '') + subItem.path;
    },
    findParentFromMenu: function findParentFromMenu(route) {
      var menu = this.menu;
      for (var i = 0, l = menu.length; i < l; i++) {
        var item = menu[i];
        var k = item.children && item.children.length;
        if (k) {
          for (var j = 0; j < k; j++) {
            if (item.children[j].name === route.name) {
              return item;
            }
          }
        }
      }
    }
  }),

  watch: {
    $route: function $route(route) {
      this.isReady = true;
      this.shouldExpandMatchItem(route);
    }
  }

};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return this.$store.state.pkg;
  }
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      username: null,
      password: null,
      rememberMe: false,
      error: null,
      waiting: false
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      this.waiting = true;
      this.$store.dispatch('auth/login', {
        username: this.username,
        password: this.password,
        rememberMe: this.rememberMe,
        callback: function callback(res) {
          _this.waiting = false;
          if (res.status === 200) {
            _this.$router.push(_this.$route.query.redirect || 'Home');
          }
        }
      });
    }
  }
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mutationTypes = __webpack_require__(4);

exports.default = {
  data: function data() {
    return {
      endpoint: {
        selection: ''
      }
    };
  },

  computed: {
    api: function api() {
      return {
        options: this.$store.state.endpointOptions
      };
    }
  },
  mounted: function mounted() {
    this.endpoint.selection = this.$store.state.endpoint;
  },

  methods: {
    setEndpoint: function setEndpoint() {
      var _this = this;

      var selectedObject = this.api.options.find(function (i) {
        return i.name === _this.endpoint.selection;
      });
      this.$store.commit(_mutationTypes.UPDATE_ENDPOINT, selectedObject.name);
      if (!this.$store.getters['auth/ok']) {
        this.$store.dispatch('auth/logout');
        this.$router.push('Home');
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//

exports.default = {

  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    separator: String
  },

  mounted: function mounted() {
    if (this.separator) {
      this.$el.style.setProperty('--separator', '"' + this.separator + '"');
    }
  },


  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      return item.meta && item.meta.label || item.name;
    }
  }
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  methods: {
    beforeEnter: function beforeEnter(el) {
      el.classList.remove('collapse');
      el.style.display = 'block';
      el.classList.add('collapsing');
      el.style.height = el.scrollHeight + 'px';
    },
    afterEnter: function afterEnter(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse', 'in');
    },
    beforeLeave: function beforeLeave(el) {
      el.classList.add('collapsing');
      el.classList.remove('collapse', 'in');
      el.style.height = 0;
    },
    afterLeave: function afterLeave(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse');
      el.style.display = 'none';
    }
  }

};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: 'nprogress-container'
};

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/icon.bca1851.png";

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/logo.02624fd.svg";

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(86)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(117),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(84)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(115),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(95)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(126),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(93)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(124),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(127),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(89)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(120),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(82)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(113),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(91)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(122),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(87)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(118),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(90)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(121),
  /* scopeId */
  "data-v-5ac2ff78",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(92)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(123),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications"
  })
},staticRenderFns: []}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('h1', {
    staticClass: "is-title is-bold"
  }, [_vm._v("Login")]), _c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticStyle: {
      "color": "red",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "email@example.org"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": "disabled"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, null) > -1 : (_vm.rememberMe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  }), _vm._v("\nRemember me")])]), _c('hr'), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Login")]), _c('router-link', {
    staticClass: "button is-default",
    attrs: {
      "to": "Home"
    }
  }, [_vm._v("Cancel")])], 1)])])])])])
},staticRenderFns: []}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: ['notification', 'animated', _vm.type ? ("is-" + _vm.type) : '']
  }, [_c('button', {
    staticClass: "delete touchable",
    on: {
      "click": function($event) {
        _vm.closedByUser()
      }
    }
  }), _vm._v(" "), (_vm.title) ? _c('div', {
    staticClass: "title is-5"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.message) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor is-vertical"
  }, [_c('div', {
    staticClass: "tile is-parent is-4"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Select Endpoint")]), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Endpoint")]), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endpoint.selection),
      expression: "endpoint.selection"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.endpoint, "selection", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.setEndpoint]
    }
  }, _vm._l((_vm.api.options), function(opt) {
    return _c('option', {
      domProps: {
        "value": opt.name
      }
    }, [_vm._v(_vm._s(opt.name))])
  }))])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nprogress-container'), _vm._v(" "), _c('navbar', {
    attrs: {
      "show": true
    }
  }), _vm._v(" "), _c('div', [_c('sidebar', {
    attrs: {
      "show": _vm.sidebar.opened && !_vm.sidebar.hidden
    }
  }), _vm._v(" "), _c('app-main')], 1), _vm._v(" "), _c('footer-bar'), _vm._v(" "), _c('notifications')], 1)
},staticRenderFns: []}

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', [(_vm.isLast(index)) ? _c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(_vm.showName(item)))])], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar app-navbar animated",
    class: {
      slideInDown: _vm.show, slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_vm._m(0), _c('div', {
    staticClass: "navbar-burger {'is-active': sidebar.opened}",
    on: {
      "click": function($event) {
        _vm.toggleSidebar({
          opened: !_vm.sidebar.opened
        })
      }
    }
  }, [_c('span'), _c('span'), _c('span')])]), _c('div', {
    staticClass: "navbar-menu navbar-end"
  }, [_c('div', {
    staticClass: "navbar-item has-dropdown is-hoverable"
  }, [_c('router-link', {
    staticClass: "navbar-link",
    attrs: {
      "to": "/settings"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-cog"
  })]), _vm._v("Settings")]), _c('div', {
    staticClass: "navbar-dropdown is-right"
  }, [_vm._m(1), _vm._l((_vm.api.options), function(opt) {
    return _c('a', {
      staticClass: "navbar-item",
      attrs: {
        "data-value": opt.name
      },
      on: {
        "click": _vm.setEndpoint
      }
    }, [_vm._v(_vm._s(opt.name))])
  }), _c('hr', {
    staticClass: "navbar-divider"
  }), _c('div', {
    staticClass: "navbar-item"
  }, [_vm._v("Version: " + _vm._s(_vm.pkginfo.version))])], 2)], 1), (!_vm.auth) ? _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/login"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-key"
  })]), _vm._v(" Login")]) : _vm._e(), (_vm.auth) ? _c('a', {
    staticClass: "navbar-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(2), _vm._v(" Logout")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "hero-brand navbar-item",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(100)
    }
  }), _c('span', {
    staticClass: "is-hidden-mobile"
  }, [_c('span', {
    staticClass: "co-name"
  }, [_vm._v("Triseum")]), _c('strong', {
    staticClass: "admin"
  }, [_vm._v("Admin")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-item"
  }, [_c('b', [_vm._v("Endpoints")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterEnter": _vm.afterEnter,
      "beforeLeave": _vm.beforeLeave,
      "afterLeave": _vm.afterLeave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu app-sidebar animated",
    class: {
      slideInLeft: _vm.show, slideOutLeft: !_vm.show
    }
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v(_vm._s(_vm.userRole))]), _c('ul', {
    staticClass: "menu-list"
  }, [_vm._l((_vm.menu), function(item, index) {
    return _c('li', [(item.path) ? _c('router-link', {
      attrs: {
        "to": item.path,
        "exact": true,
        "aria-expanded": _vm.isExpanded(item) ? 'true' : 'false'
      },
      nativeOn: {
        "click": function($event) {
          _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n" + _vm._s(item.meta.label || item.name)), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]) : _c('a', {
      attrs: {
        "aria-expanded": _vm.isExpanded(item)
      },
      on: {
        "click": function($event) {
          _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n" + _vm._s(item.meta.label || item.name)), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]), (item.children && item.children.length) ? _c('expanding', [_c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExpanded(item)),
        expression: "isExpanded(item)"
      }]
    }, _vm._l((item.children), function(subItem) {
      return (subItem.path) ? _c('li', [_c('router-link', {
        attrs: {
          "to": _vm.generatePath(item, subItem)
        }
      }, [_vm._v(_vm._s(subItem.meta && subItem.meta.label || subItem.name))])], 1) : _vm._e()
    }))]) : _vm._e()], 1)
  }), (_vm.device.isMobile) ? _c('li', [_c('hr')]) : _vm._e(), (_vm.device.isMobile) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-cog"
  })]), _vm._v("\n Settings")])], 1) : _vm._e(), (_vm.device.isMobile) ? _c('li', [(!_vm.auth) ? _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-key"
  })]), _vm._v("\n Login")]) : _vm._e(), (_vm.auth) ? _c('a', {
    staticClass: "navbar-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(0), _vm._v("\n Logout")]) : _vm._e()], 1) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nprogress-container"
  })
},staticRenderFns: []}

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  })])])
}]}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_c('img', {
    attrs: {
      "width": "200",
      "src": __webpack_require__(101),
      "alt": _vm.description
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "is-title is-bold"
  }, [_vm._v(_vm._s(_vm.name.replace('-', ' ')))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.description))])])])
},staticRenderFns: []}

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main",
    style: ([_vm.hiddenSidebarStyle])
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless app-content"
  }, [_c('levelbar'), _c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "appear": ""
    }
  }, [_c('router-view', {
    staticClass: "animated"
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "level app-levelbar"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('h3', {
    staticClass: "subtitle is-5"
  }, [_c('strong', [_vm._v(_vm._s(_vm.name))]), _vm._v("("), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.endpoint))])]), _vm._v(")")], 1)])]), _c('div', {
    staticClass: "level-right is-hidden-mobile"
  }, [_c('breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, exports) {

module.exports = {"name":"triseum-admin","version":"1.6.0","description":"Triseum Admin Panel Interface based on VueAdmin 0.1.12","license":"MIT","author":{"name":"Fangdun Cai","email":"cfddream@gmail.com","url":"fundon.me"},"config":{"modified":"2018-08-31"},"keywords":["admin","bulma","dashboard","data","visualization","vue"],"engines":{"node":">=4","npm":">=3"},"scripts":{"build":"cross-env NODE_ENV=production node build/build.js","clean":"rm -rf dist","dev":"cross-env NODE_ENV=development node build/dev-server.js","electron":"cross-env NODE_ELECTRON=true npm run build && electron electronIndex.js","sync":"sync.js","deploy":"yarn run build && yarn run sync","lint":"eslint --ext .js .vue client/*","lint:fix":"eslint --fix --ext .js .vue electron.js client/* build/* config/*","test":"echo lol"},"dependencies":{"@voerro/vue-tagsinput":"^1.6.0","animejs":"^2.0.1","axios":"^0.15.3","base64-js":"^1.2.3","bulma":"^0.6.2","classnames":"^2.2.5","font-awesome":"4.7.0","hint.css":"^2.5.0","lodash":"^4.17.5","plotly.js":"^1.24.2","pug":"^2.0.3","vue":"^2.2.2","vue-bulma-breadcrumb":"^1.0.1","vue-bulma-card":"^1.0.2","vue-bulma-chartist":"^1.1.0","vue-bulma-chartjs":"^1.0.4","vue-bulma-collapse":"1.0.3","vue-bulma-datepicker":"^1.3.0","vue-bulma-emoji":"^0.0.2","vue-bulma-expanding":"^0.0.1","vue-bulma-jump":"^0.0.2","vue-bulma-message":"^1.1.1","vue-bulma-modal":"1.0.1","vue-bulma-progress-bar":"^1.0.2","vue-bulma-progress-tracker":"0.0.4","vue-bulma-quill":"0.0.1","vue-bulma-rating":"^1.0.1","vue-bulma-slider":"^1.0.2","vue-bulma-switch":"^1.0.4","vue-bulma-tabs":"^1.1.2","vue-cleave":"1.1.1","vue-codemirror-lite":"^1.0.4","vue-lory":"0.0.4","vue-nprogress":"0.1.5","vue-peity":"0.5.0","vue-router":"^2.3.0","vuex":"^2.2.1","vuex-persistedstate":"^2.5.4","vuex-router-sync":"^4.1.2","wysiwyg.css":"0.0.2"},"devDependencies":{"autoprefixer":"^6.7.7","babel-core":"^6.21.0","babel-eslint":"^7.1.1","babel-loader":"^6.4.0","babel-plugin-transform-export-extensions":"^6.8.0","babel-preset-env":"^1.7.0","babel-preset-es2015":"^6.14.0","babel-preset-stage-2":"^6.17.0","connect-history-api-fallback":"^1.3.0","cross-env":"^3.1.3","css-loader":"^0.27.1","electron-devtools-installer":"^2.0.1","eslint":"^3.17.1","eslint-config-standard":"^7.0.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.6.1","eslint-plugin-html":"^2.0.1","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^2.1.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^2.0.0-beta.4","file-loader":"^0.10.1","html-webpack-plugin":"^2.25.0","http-proxy-middleware":"^0.17.4","imports-loader":"^0.7.0","node-sass":"^4.1.1","opn":"^4.0.2","ora":"^1.1.0","postcss-loader":"^1.3.3","progress-bar-webpack-plugin":"^1.9.1","sass-loader":"^6.0.3","serve-favicon":"^2.4.1","style-loader":"^0.13.1","stylus":"^0.54.5","stylus-loader":"^3.0.1","url-loader":"^0.5.7","vue-html-loader":"^1.2.3","vue-loader":"^11.1.4","vue-template-compiler":"^2.2.2","webpack":"^2.2.1","webpack-dev-middleware":"^1.9.0","webpack-hot-middleware":"^2.14.0","webpack-merge":"^4.0.0"}}

/***/ })
],[27]);


// WEBPACK FOOTER //
// assets/js/app.6c5b9f63ffe5a1a0b81f.js